/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface QuestionTypeIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * TextFieldIcon component - Icon for text field question type
 * @param size - Icon size in pixels (default: 24)
 * @param color - Icon color (default: colors.NEUTRAL_50)
 * @param className - Additional CSS class name
 */
const TextFieldIcon = ({
  size = 24,
  color = colors.NEUTRAL_50,
  className,
}: QuestionTypeIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
      className={className}
    >
      <path
        d='M5 9.5H19C19.55 9.5 20 9.95 20 10.5C20 11.05 19.55 11.5 19 11.5H5C4.45 11.5 4 11.05 4 10.5C4 9.95 4.45 9.5 5 9.5ZM5 13.5H13C13.55 13.5 14 13.95 14 14.5C14 15.05 13.55 15.5 13 15.5H5C4.45 15.5 4 15.05 4 14.5C4 13.95 4.45 13.5 5 13.5Z'
        fill={color}
      />
    </svg>
  )
}

export default TextFieldIcon
